/**
 * Runtime Backend URL Resolution
 * 
 * REACT_APP_BACKEND_URL is baked at build time by webpack.
 * In production deployments with custom domains, the build-time URL
 * may not match the actual domain the app is served from.
 * 
 * This utility resolves the correct backend URL at runtime:
 * - If the app is on a custom domain different from the build-time URL,
 *   use empty string (relative URLs work because frontend+backend share the same domain)
 * - Otherwise use the build-time REACT_APP_BACKEND_URL
 */

const BUILD_TIME_URL = process.env.REACT_APP_BACKEND_URL || '';

function resolveBackendUrl() {
  // In server-side or test environments, use build-time value
  if (typeof window === 'undefined') return BUILD_TIME_URL;

  const currentOrigin = window.location.origin;

  // If build-time URL is empty, use relative URLs
  if (!BUILD_TIME_URL) return '';

  // If we're on the same domain as build-time URL, use it directly
  try {
    const buildOrigin = new URL(BUILD_TIME_URL).origin;
    if (currentOrigin === buildOrigin) return BUILD_TIME_URL;
  } catch (e) {
    // Invalid build-time URL, fall through
  }

  // If current domain is different from build-time URL,
  // we're likely on a custom production domain.
  // Use empty string (relative URL) since frontend+backend share the domain.
  return '';
}

export const BACKEND_URL = resolveBackendUrl();
export default BACKEND_URL;
